import { NavigationLink } from '../models/Header';

import { PrivacyPolicySection } from './../models/Privacy';

export const privacyLinks: NavigationLink[] = [
  {
    id: 0,
    title: 'about',
    linkTo: '/about',
  },
  {
    id: 1,
    title: 'expertise',
    linkTo: '/#expertise',
  },
  {
    id: 2,
    title: 'projects',
    linkTo: '/projects',
  },
  // {
  //   id: 3,
  //   title: 'journal',
  //   linkTo: '/journal',
  // },
  {
    id: 3,
    title: 'contact',
    linkTo: '/#contact',
  },
];

export const privacySections: PrivacyPolicySection[] = [
  {
    title: '1.1 Lorem Ipsum',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
  },
];
